import type { TFunction } from "i18next";
import { DOCUMENT_TYPE } from "../enums";

/** Resolves column header text; overrides remote `tableHeaders.*` where document-type-specific wording is needed. */
export function getDocumentTableHeaderLabel(
  key: string,
  docType: number | undefined,
  t: TFunction,
): string {
  if (key === "customerSupportRepresentative") {
    return t("usersSettings.isCustomerSupportRepresentative");
  }
  if (key === "uploadedFilesCount") {
    return t("tableHeaders.uploadedFilesCount", {
      defaultValue: "Uploaded Files",
    });
  }
  if (key === "termOfPayment") {
    return t("sales.quote.paymentTerms", {
      defaultValue: "Payment terms",
    });
  }
  if (key === "title") {
    return t("tableHeaders.title", { defaultValue: "Title" });
  }
  if (docType === DOCUMENT_TYPE.purchaseOrder && key === "orderNumber") {
    return t("sales.quote.orderNumbers");
  }
  return t(`tableHeaders.${key}`);
}
